export default __webpack_public_path__ + "static/helles_badge-203138534aa324e908b4a339d52398c7.svg";